import { useCallback, useEffect } from 'react'
import { useLocation, useSearchParams } from 'react-router'

export const metricsFilters = [
  'from',
  'to',
  'grouped_by',
  'project_id',
  'org_id',
  'range_value',
]

export default function useMetricsSearchParams() {
  const [searchParams, setSearchParams] = useSearchParams()
  const { pathname } = useLocation()

  const filterValues: Record<string, string> = metricsFilters.reduce(
    (acc, filter) => ({ ...acc, [filter]: searchParams.get(filter) }),
    {},
  )

  const updateValues = useCallback(
    (keyValuePairs: Record<string, string>) => {
      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev)
        Object.entries(keyValuePairs).forEach(([key, value]) => {
          if (value === 'all' || value === '') {
            newParams.delete(key)
          } else {
            newParams.set(key, value)
          }
        })
        return newParams
      })
    },
    [setSearchParams],
  )

  const resetAllFilters = useCallback(() => {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev)
      metricsFilters.forEach((filter) => {
        newParams.delete(filter)
      })
      return newParams
    })
  }, [setSearchParams])

  useEffect(() => {
    if (!pathname.includes('metrics') && !pathname.includes('customers')) {
      resetAllFilters()
    }
  }, [pathname, resetAllFilters])

  return {
    values: filterValues,
    updateValues,
    resetAllFilters,
  }
}
